import { FC, useState } from "react";
import { Drawer } from "antd";
import { MdKeyboardArrowUp } from "react-icons/md";
import PaymentDetails from "./PaymentDetails";
import { useTranslation } from "react-i18next";

interface Props {
  data: any;
}

const MobilePaymentDrawer: FC<Props> = ({ data }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="fixed bottom-0 start-0 right-0 z-50 bg-background-minimal rounded-t-xl shadow-[0_-4px_20px_rgba(0,0,0,0.12)]">
        <button
          className="w-full flex flex-col items-center pt-3 pb-5 focus:outline-none"
          onClick={() => setOpen(true)}
        >
          <div className="w-10 h-0.5 rounded-full bg-border-default mb-4" />
          <div className="flex w-full items-center justify-between px-4 text-sm font-semibold text-font-default">
            <span>{t("UserHistory.flight.paymentDetails")}</span>
            <MdKeyboardArrowUp className="w-4 h-4 text-icon-subtle" />
          </div>
        </button>
      </div>
      <Drawer
        open={open}
        onClose={() => setOpen(false)}
        placement="bottom"
        size="90dvh"
        className="rounded-t-xl!"
          styles={{
          header: { display: "none" },
          body: { padding: 0, overflowY: "auto" },
          wrapper: { borderRadius: "1rem 1rem 0 0" },
        }}
      >
        <div className="flex flex-col h-full gap-3 p-4">
          <div className="flex items-center justify-between px-4 pt-4 pb-">
            <span className="font-semibold text-base">{t("UserHistory.flight.paymentDetails")}</span>
            <button
              onClick={() => setOpen(false)}
              className="text-font-minimal text-sm font-medium"
            >
              {t("UserHistory.flight.close")}
            </button>
          </div>
          <div className="flex-1 overflow-y-auto px-4 pb-4">
            <PaymentDetails data={data} />
          </div>
        </div>
      </Drawer>
    </>
  );
};

export default MobilePaymentDrawer;
